import { Close } from "@mui/icons-material";
import { TextField, InputAdornment, IconButton } from "@mui/material";
import { useEffect, useState } from "react";

import { useProviderSearchStore } from "../../store/providerSearchStore";
import STYLES from "../../style/style";

export default function ProviderNameSearchField({ placeholder, searchText, setSearchText }) {
  const { setAssignedProvider, resetCurrentPage, setInNetwork } = useProviderSearchStore();
  const [localSearch, setLocalSearch] = useState(searchText || "");

  useEffect(() => {
    const handler = setTimeout(() => {
      setSearchText(localSearch);
      setAssignedProvider(null);
      resetCurrentPage();
    }, 700);

    return () => clearTimeout(handler);
  }, [localSearch, setSearchText]);

  const handleClear = () => {
    setAssignedProvider(null);
    setInNetwork(1);
    setLocalSearch("");
    setSearchText("");
  };

  return (
    <div className="flex-1">
      <TextField
        id="search-bar"
        placeholder={placeholder}
        className="w-full"
        variant="outlined"
        value={localSearch}
        onChange={(e) => setLocalSearch(e.target.value)}
        InputLabelProps={{ shrink: true }}
        InputProps={{
          endAdornment: localSearch ? (
            <InputAdornment position="end" className="p-4">
              <IconButton onClick={handleClear} edge="end" size="small">
                <Close fontSize="small" />
              </IconButton>
            </InputAdornment>
          ) : null,
        }}
        sx={{
          ...STYLES.textField,
          "& .MuiInputLabel-root": {
            ...STYLES.label(false),
          },
        }}
        size="small"
      />
    </div>
  );
}
